// extracted by mini-css-extract-plugin
export var active = "_bf-2";
export var highlight = "_bf-1";
export var highlightLayer = "_bf-0";
export var issuePopover = "_bf-3";
export var statusIcon = "_bf-4";